// exports
export default {
  HOME: '/',
  GAME: '/play',
  HEROES: '/heroes',
  BACKPACK: '/backpack',
  PROFILE: '/profile',
  ACTIVITY: '/profile/activity',
  SETTINGS: '/profile/settings',
  ITEM_COLLECTION: '/profile/items',
  HERO_COLLECTION: '/profile/heroes',
  QUESTS: '/quests',
  QUEST_CREW: '/quests/:id/crew'
} as const;
